import { useContext } from 'react';
import { CompanyBrandingContext } from '../context';

export function useCompanyBranding() {
  const { companyBranding, setCompanyBranding } = useContext(
    CompanyBrandingContext
  );
  return [companyBranding, setCompanyBranding] as const;
}
